import { useEffect, useMemo, useRef } from "react";

let passiveIfSupported: boolean | { passive: boolean } = false;

try {
  window.addEventListener(
    "test",
    () => {},
    Object.defineProperty({}, "passive", {
      get: function () {
        passiveIfSupported = { passive: true } as { passive: boolean };
      },
    }),
  );
} catch (err) {}

// passive 옵션을 이용하면 이벤트 리스너가 preventDefault()를 호출하지 않을 것임을 브라우저에 알려줘서
// 스크롤이나 휠과 같은 이벤트가 바로 처리되도록 합니다.
export const useEvent = (event: string, callback: any, passive?: boolean) => {
  const rafIdRef = useRef<number | undefined>(undefined);

  const handler = useMemo(() => {
    return event === "scroll"
      ? () => {
          if (rafIdRef.current) {
            cancelAnimationFrame(rafIdRef.current);
          }
          rafIdRef.current = requestAnimationFrame(callback);
        }
      : callback;
  }, [callback, event]);

  useEffect(() => {
    handler();

    window.addEventListener(event, handler, passiveIfSupported);
    return () => window.removeEventListener(event, handler);
  }, [callback, event, handler]);
};
